import React from 'react';
import PropTypes from 'prop-types';

import CouponOfferComponent from './CouponOfferComponent';
import { CashbackOfferComponent } from './CashbackOfferComponent';
import PartnerBlockHorizontalComponent from '../../../partner/PartnerBlockHorizontalComponent';

import './ModalOfferComponent.scss';

export class ModalOfferComponent extends React.Component {
    renderConditionnalTitle(partner) {
        return partner && partner.name ? partner.name : '';
    }

    extractOrBlank(str) {
        return str ? ` ${str}` : '';
    }

    render() {
        const { partner, coupon, discount } = this.props;
        if (partner) {
            return (
                <section className="interstitiel-modal-offer flex flex-h">
                    <PartnerBlockHorizontalComponent partner={partner} noLogoLink>
                        <CouponOfferComponent partner={partner} coupon={coupon} />
                        <CashbackOfferComponent
                            partner={partner}
                            withCoupon={coupon && coupon.id > 0}
                            discount={discount}
                        />
                    </PartnerBlockHorizontalComponent>
                </section>
            );
        }
        return null;
    }
}

ModalOfferComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    coupon: PropTypes.object,
    discount: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/ModalOfferComponent.js